import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import {
  StyledButton,
  StyledBackButton,
  StyledCloseButton,
  CloseIcon,
  BackIcon
} from './styled';

const Button = forwardRef(
  (
    { onClick, disabled = false, variant = 'primary', children, ...props },
    forwardedRef
  ) => (
    <StyledButton
      ref={forwardedRef}
      onClick={!disabled ? onClick : undefined}
      variant={disabled ? 'disabled' : variant}
      disabled={disabled}
      type="button"
      {...props}
    >
      {children}
    </StyledButton>
  )
);

Button.displayName = 'Button';

Button.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  variant: PropTypes.string,
  disabled: PropTypes.bool
};

Button.defaultProps = {
  variant: 'primary',
  disabled: false
};

export default Button;

export const BackButton = ({
  onClick,
  disabled = false,
  variant,
  children,
  ...props
}) => {
  return (
    <StyledBackButton
      onClick={onClick}
      disabled={disabled}
      type="button"
      variant={disabled ? 'disabled' : variant}
      {...props}
    >
      <BackIcon />
      {children}
    </StyledBackButton>
  );
};

BackButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  variant: PropTypes.string,
  disabled: PropTypes.bool
};

BackButton.defaultProps = {
  variant: 'light',
  disabled: false,
  children: 'Back'
};

export const CloseButton = ({ onClick, ...props }) => {
  return (
    <StyledCloseButton type="button" onClick={onClick} {...props}>
      <CloseIcon />
    </StyledCloseButton>
  );
};

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
